/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface OrganizationsService {
  /** @summary Get All */
  getAllOrganizationsGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllOrganizationsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllOrganizationsGetSchema,
        options: {
          parameters: GetAllOrganizationsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllOrganizationsGetData, GetAllOrganizationsGetError>>
    ): Promise<RequestFnResponse<GetAllOrganizationsGetData, GetAllOrganizationsGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllOrganizationsGetParameters> | void
    ): ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.organizationsService.getAllOrganizationsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllOrganizationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllOrganizationsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.organizationsService.getAllOrganizationsGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllOrganizationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllOrganizationsGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllOrganizationsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.organizationsService.getAllOrganizationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllOrganizationsGetParameters,
      TQueryFnData = GetAllOrganizationsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllOrganizationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllOrganizationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllOrganizationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.organizationsService.getAllOrganizationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllOrganizationsGetParameters,
      TQueryFnData = GetAllOrganizationsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllOrganizationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllOrganizationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllOrganizationsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllOrganizationsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllOrganizationsGetTotal = qraft.organizationsService.getAllOrganizationsGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllOrganizationsGetResults = qraft.organizationsService.getAllOrganizationsGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOrganizationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllOrganizationsGetCombinedResults = qraft.organizationsService.getAllOrganizationsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOrganizationsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllOrganizationsGetSchema,
          GetAllOrganizationsGetParameters,
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllOrganizationsGetData, GetAllOrganizationsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllOrganizationsGetData, GetAllOrganizationsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.organizationsService.getAllOrganizationsGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllOrganizationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError,
          TData,
          ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllOrganizationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.organizationsService.getAllOrganizationsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllOrganizationsGetParameters, TData = GetAllOrganizationsGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError,
          OperationInfiniteData<TData, GetAllOrganizationsGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllOrganizationsGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllOrganizationsGetParameters>,
      OperationError<GetAllOrganizationsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllOrganizationsGetData = qraft.organizationsService.getAllOrganizationsGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOrganizationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllOrganizationsGetCombinedData = qraft.organizationsService.getAllOrganizationsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllOrganizationsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllOrganizationsGetSchema,
          GetAllOrganizationsGetParameters,
          GetAllOrganizationsGetData,
          GetAllOrganizationsGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllOrganizationsGetData, GetAllOrganizationsGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetAllOrganizationsGetData, GetAllOrganizationsGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        GetAllOrganizationsGetError
      > | void
    ): Promise<GetAllOrganizationsGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        GetAllOrganizationsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        GetAllOrganizationsGetError
      > | void
    ): Promise<GetAllOrganizationsGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllOrganizationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOrganizationsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllOrganizationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOrganizationsGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllOrganizationsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        GetAllOrganizationsGetParameters,
        DeepReadonly<TPageParam>,
        GetAllOrganizationsGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void)
    ): GetAllOrganizationsGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void)
    ): OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
            data: GetAllOrganizationsGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | (DeepReadonly<GetAllOrganizationsGetParameters> | void)
    ): QueryState<GetAllOrganizationsGetData, GetAllOrganizationsGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllOrganizationsGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>,
          GetAllOrganizationsGetError
        >
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllOrganizationsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
      updater: Updater<
        NoInfer<GetAllOrganizationsGetData> | undefined,
        NoInfer<DeepReadonly<GetAllOrganizationsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllOrganizationsGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllOrganizationsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllOrganizationsGetSchema, GetAllOrganizationsGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllOrganizationsGetData, GetAllOrganizationsGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >,
      updater: Updater<
        NoInfer<GetAllOrganizationsGetData> | undefined,
        NoInfer<GetAllOrganizationsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllOrganizationsGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllOrganizationsGetSchema,
        GetAllOrganizationsGetData,
        TInfinite,
        GetAllOrganizationsGetParameters,
        GetAllOrganizationsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
        | QueryFiltersByQueryKey<
            GetAllOrganizationsGetSchema,
            GetAllOrganizationsGetData,
            TInfinite,
            GetAllOrganizationsGetParameters,
            GetAllOrganizationsGetError
          >
    ): number;
    schema: GetAllOrganizationsGetSchema;
    types: {
      parameters: GetAllOrganizationsGetParameters;
      data: GetAllOrganizationsGetData;
      error: GetAllOrganizationsGetError;
    };
  };
  /** @summary Setup */
  setupOrganizationsSetupPost: {
    /** @summary Setup */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SetupOrganizationsSetupPostBody,
        SetupOrganizationsSetupPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SetupOrganizationsSetupPostSchema,
        options: ServiceOperationMutationFnOptions<
          SetupOrganizationsSetupPostBody,
          SetupOrganizationsSetupPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SetupOrganizationsSetupPostData, SetupOrganizationsSetupPostError>>
    ): Promise<RequestFnResponse<SetupOrganizationsSetupPostData, SetupOrganizationsSetupPostError>>;
    /** @summary Setup */
    getMutationKey(
      parameters: DeepReadonly<SetupOrganizationsSetupPostParameters> | void
    ): ServiceOperationMutationKey<SetupOrganizationsSetupPostSchema, SetupOrganizationsSetupPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.organizationsService.setupOrganizationsSetupPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.organizationsService.setupOrganizationsSetupPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SetupOrganizationsSetupPostBody, TContext = unknown>(
      parameters: DeepReadonly<SetupOrganizationsSetupPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SetupOrganizationsSetupPostSchema,
        SetupOrganizationsSetupPostData,
        SetupOrganizationsSetupPostParameters,
        TVariables,
        OperationError<SetupOrganizationsSetupPostError>,
        TContext
      >
    ): UseMutationResult<
      SetupOrganizationsSetupPostData,
      OperationError<SetupOrganizationsSetupPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Setup
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.organizationsService.setupOrganizationsSetupPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.organizationsService.setupOrganizationsSetupPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SetupOrganizationsSetupPostBody, SetupOrganizationsSetupPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SetupOrganizationsSetupPostSchema,
        SetupOrganizationsSetupPostData,
        SetupOrganizationsSetupPostParameters,
        TVariables,
        OperationError<SetupOrganizationsSetupPostError>,
        TContext
      >
    ): UseMutationResult<
      SetupOrganizationsSetupPostData,
      OperationError<SetupOrganizationsSetupPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Setup
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const setupOrganizationsSetupPostTotal = qraft.organizationsService.setupOrganizationsSetupPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const setupOrganizationsSetupPostTotal = qraft.organizationsService.setupOrganizationsSetupPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupOrganizationsSetupPostSchema,
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Setup
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const setupOrganizationsSetupPostPendingMutationVariables = qraft.organizationsService.setupOrganizationsSetupPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const setupOrganizationsSetupPostMutationData = qraft.organizationsService.setupOrganizationsSetupPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SetupOrganizationsSetupPostData,
        OperationError<SetupOrganizationsSetupPostError>,
        MutationVariables<SetupOrganizationsSetupPostBody, SetupOrganizationsSetupPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupOrganizationsSetupPostSchema,
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SetupOrganizationsSetupPostData,
          OperationError<SetupOrganizationsSetupPostError>,
          MutationVariables<SetupOrganizationsSetupPostBody, SetupOrganizationsSetupPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Setup */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SetupOrganizationsSetupPostSchema,
            SetupOrganizationsSetupPostBody,
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostParameters,
            OperationError<SetupOrganizationsSetupPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Setup
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.organizationsService.setupOrganizationsSetupPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.organizationsService.setupOrganizationsSetupPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SetupOrganizationsSetupPostBody,
              SetupOrganizationsSetupPostData,
              SetupOrganizationsSetupPostParameters,
              OperationError<SetupOrganizationsSetupPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupOrganizationsSetupPostSchema,
              SetupOrganizationsSetupPostBody,
              SetupOrganizationsSetupPostData,
              SetupOrganizationsSetupPostParameters,
              OperationError<SetupOrganizationsSetupPostError>,
              TContext
            >
      ):
        | Mutation<
            SetupOrganizationsSetupPostData,
            SetupOrganizationsSetupPostError,
            MutationVariables<SetupOrganizationsSetupPostBody, SetupOrganizationsSetupPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SetupOrganizationsSetupPostBody,
              SetupOrganizationsSetupPostData,
              SetupOrganizationsSetupPostParameters,
              OperationError<SetupOrganizationsSetupPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SetupOrganizationsSetupPostSchema,
              SetupOrganizationsSetupPostBody,
              SetupOrganizationsSetupPostData,
              SetupOrganizationsSetupPostParameters,
              OperationError<SetupOrganizationsSetupPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SetupOrganizationsSetupPostData,
          SetupOrganizationsSetupPostError,
          MutationVariables<SetupOrganizationsSetupPostBody, SetupOrganizationsSetupPostParameters>,
          TContext
        >
      >;
    };
    schema: SetupOrganizationsSetupPostSchema;
    types: {
      parameters: SetupOrganizationsSetupPostParameters;
      data: SetupOrganizationsSetupPostData;
      error: SetupOrganizationsSetupPostError;
      body: SetupOrganizationsSetupPostBody;
    };
  };
}
/** @summary Get All */
export const getAllOrganizationsGet = {
  schema: {
    method: 'get',
    url: '/organizations',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllOrganizationsGetSchema;
  [QraftServiceOperationsToken]: OrganizationsService['getAllOrganizationsGet'];
};
/** @summary Setup */
export const setupOrganizationsSetupPost = {
  schema: {
    method: 'post',
    url: '/organizations/setup',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SetupOrganizationsSetupPostSchema;
  [QraftServiceOperationsToken]: OrganizationsService['setupOrganizationsSetupPost'];
};
export const organizationsService = {
  getAllOrganizationsGet,
  setupOrganizationsSetupPost,
} as const;
type GetAllOrganizationsGetSchema = {
  method: 'get';
  url: '/organizations';
  security: ['HTTPBearer'];
};
type GetAllOrganizationsGetParameters = undefined;
type GetAllOrganizationsGetData = paths['/organizations']['get']['responses']['200']['content']['application/json'];
type GetAllOrganizationsGetError = unknown;
type SetupOrganizationsSetupPostSchema = {
  method: 'post';
  url: '/organizations/setup';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SetupOrganizationsSetupPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SetupOrganizationsSetupPostData =
  paths['/organizations/setup']['post']['responses']['201']['content']['application/json'];
type SetupOrganizationsSetupPostError =
  paths['/organizations/setup']['post']['responses']['422']['content']['application/json'];
type SetupOrganizationsSetupPostBody =
  paths['/organizations/setup']['post']['requestBody']['content']['application/json'];
